import "./style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ban1 from "../../images/selection produits/1.jpg";
import ban2 from "../../images/selection produits/2.jpg";
import ban3 from "../../images/selection produits/3.jpg";
import ban4 from "../../images/selection produits/4.jpg";
import ban5 from "../../images/selection produits/5.jpg";
import ban6 from "../../images/selection produits/6.jpg";
import { useInView } from "framer-motion";
import { useRef } from "react";

const slugify = (text = "") =>
  text
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, "et")
    .replace(/[^a-z0-9/\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

export default function SelectionProduct() {
  const ref2 = useRef(null);
  const isInView2 = useInView(ref2, { once: true });

  return (
    <div
      ref={ref2}
      style={{
        transform: isInView2 ? "none" : "translateY(200px)",
        opacity: isInView2 ? 1 : 0,
        transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
      }}
    >
      <div className="categorieProduct">
        <div className="carousselDivHomeProduct">
          <div className="carouselDivHProduct">
            <a
              href={slugify(
                "/produit/électroménager & cuisine/cuisine/preparation culinaire/DECA BLENDER 1.5L 650W KEJB045L"
              )}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={ban1}
                alt="weeklypromo"
                className="banPromoPicProduct"
              />
            </a>

            <div className="carouselDivVProduct">
              <a
                href={slugify(
                  "/produit/informatique & lifestyle/lifestyle/beaute & sante/rasoir et tendeuse/RASOIR SECTEUR ROTATIF REM"
                )}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={ban2}
                  alt="weeklypromo"
                  className="banPromoPic2product"
                />
              </a>

              <a
                href={slugify(
                  "/produit/informatique & lifestyle/lifestyle/beaute & sante/maternite/BABYPHONE WIFI AVEC CAMERA"
                )}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={ban3}
                  alt="weeklypromo"
                  className="banPromoPic2product"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="carousselDivHomeProduct">
          <div className="carouselDivHProduct">
            <a
              href={slugify(
                "/produit/électroménager & cuisine/cuisine/appareil de cuission/AIR FRYER 4 LITRES NOIR et CHROME"
              )}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={ban4}
                alt="weeklypromo"
                className="banPromoPicProduct"
              />
            </a>

            <div className="carouselDivVProduct">
              <a
                href={slugify(
                  "/produit/électroménager & cuisine/maison/DECA ASPIRATEUR 5L 1800W CEVC007R"
                )}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={ban5}
                  alt="weeklypromo"
                  className="banPromoPic2product"
                />
              </a>

              <a
                href={slugify(
                  "/produit/électroménager & cuisine/cuisine/appareil de cuission/MINI FOUR VENTILE 45 LITRES VERT PISTACHE FOCUS"
                )}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={ban6}
                  alt="weeklypromo"
                  className="banPromoPic2product"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}